<template>
  <div>
    <div class="panel-height">
      <div v-if="!signerInfo" class="text-center text-muted">
        İmzacı bilgileri alınıyor.
      </div>
      <div v-else>
        <table class="table table-sm table-borderless ozet">
          <tbody>
            <tr v-show="signerInfo.User">
              <td style="width: 150px">İmzacı</td>
              <td style="width: 1px">:</td>
              <td>{{ signerInfo.User.FullName }}</td>
            </tr>
            <tr>
              <td>Operatör</td>
              <td style="width: 1px">:</td>
              <td>
                <select v-model="signerInfo.Operator" @change="ChangeOperator($event)" class="form-control" style="max-width: 180px;">
                  <option value="null">Mobil imzası yok</option>
                  <option value="TURKCELL">Turkcell</option>
                  <option value="AVEA">Türk Telekom</option>
                  <option value="VODAFONE">Vodafone</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>Numara</td>
              <td style="width: 1px">:</td>
              <td>{{ signerInfo.Number }}</td>
            </tr>
          </tbody>
        </table>
        <!-- <div class="alert alert-danger" v-show="signerInfo.Error">
          {{ signerInfo.Error }}
        </div> -->
        <div v-if="item" class="text-center">
          <div style="font-weight: bold">
            {{ item.FileName }}
          </div>
          <div v-if="item.Fingerprint">
            <p>
              <code>{{ item.Fingerprint }}</code>
            </p>
          </div>
          <div v-if="item.error" class="text-danger">{{ item.error }}</div>
        </div>
        <div v-show="timerShow"
          style="margin-top:10px; display:flex; justify-content: center; align-items: center;">
          <div id="countDown" class="counter-container">
              <circular-count-down-timer-vue ref="countdown" :circles="circles"
              :main-circle-id="'1'" :stop-conditions="{ '1': 0 }" />
          </div>
        </div>
      </div>
    </div>
    
    <div class="item-list" v-if="showFileList">
        <table class="table table-borderless table-hover">
            <tbody>
                <tr v-for="i in items" :key="i.Id">
                    <td>
                        {{i.FileName}} <small class="text-muted">{{i.Size | prettyBytes}}</small>
                        <div v-if="!i.OK && i.ModelState" class="text-muted" style="font-size:0.7rem;">
                            <div v-for="errList in i.ModelState" :key="errList">
                                <div v-for="e in errList" :key="e">{{e}}</div>
                            </div>
                        </div>
                    </td>
                    <td style="width:250px;">
                        <div v-if="i.State == signStatus.prepearing">
                            <spinner sr="Parmakizi hesaplanıyor..." />
                            Parmakizi hesaplanıyor...
                        </div>
                        <div v-else-if="i.State == signStatus.signing">
                            <spinner sr="İmza bekleniyor..." />
                            İmza bekleniyor...
                        </div>
                        <div v-else-if="i.State == signStatus.sending">
                            <spinner sr="Gönderiliyor..." />
                            Gönderiliyor
                        </div>
                        <div v-else-if="i.State == signStatus.completed">
                            <icon-check class="text-success"/>
                            Tamamlandı
                        </div>
                        <div v-else-if="i.State == signStatus.canceled">
                            <icon-exclamation-triangle class="text-warning" />
                            İptal edildi
                        </div>
                        <div v-else-if="i.State == signStatus.error">
                            <icon-exclamation-octagon class="text-danger" />
                            Hata
                        </div>
                        <div v-else>{{i.State}}</div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div v-if="eSignAgreement">
      <p>Devam etmeniz halinde aşağıdaki metin tarafınızdan imzalanacaktır.</p>
      <div class="alert alert-primary" role="alert">
        <h4 class="alert-heading d-flex align-items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            class="bi flex-shrink-0 mr-2"
            viewBox="0 0 16 16"
            role="img"
            aria-label="Info:"
          >
            <path
              d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
            />
          </svg>
          {{ eSignAgreement.SigningFileName }}
        </h4>
        <hr />
        <div>
          {{ eSignAgreement.SigningText }}
        </div>
      </div>
    </div>

    <div class="text-danger" v-show="this.error">{{this.error}}</div>
    <div v-show="processingMessage" class="text-center text-primary" style="line-height:32px;">
        <spinner/>
        {{processingMessage}}
    </div>
  </div>
</template>
<script>
import axios from "axios";
import spinner from '@/components/Spinner.vue'
import iconCheck from '@/components/Icons/check.svg'
import iconExclamationOctagon from '@/components/Icons/exclamation-octagon.svg'
import iconExclamationTriangle from '@/components/Icons/exclamation-triangle.svg'
import CircularCountDownTimerVue from "./CircularCountDownTimer.vue";

const signStatus = {
    prepearing: 'prepearing',
    signing: 'signing',
    sending: 'sending',
    completed: 'completed',
    canceled: 'canceled',
    error: 'error'
};

export default {
  components: {
    spinner,
    iconCheck,
    iconExclamationOctagon,
    iconExclamationTriangle,
    CircularCountDownTimerVue,
  },
  props: {
    items: Array,
    processingMessage: null, // İşlem yapılıyor, lütfen bekleyin mesajı. Dosyaların imzalanması tamamlandıktan sonra sunucuya gönderilirken gösterilmek üzere...
    showFileList: {
      default: true,
      type: Boolean,
    },
    eSignAgreement: Object
  },
  data() {
    return {
      error: "",
      signStatus: signStatus,
      signerInfo: null, // İmzacı bilgileri
      item: null, // Şu anda imzalanmakta olan dosya
      loading: false,
      timerShow: false,
      circles: [
        {
            strokeColor: "#17a2b8",
            strokeWidth: 3,
            id: '1',
            steps: 60,
            size: 50,
            value: 60,
            stepLength: -1,
        }
      ],
    };
  },
  created() {
    axios
      .get("/mobilesign/signerinfo")
      .then((x) => {
        this.signerInfo = x.data.Data;
        console.log("signerInfo:", this.signerInfo);
      })
      .catch((x) => {
        this.signerInfo = {
          Error: "Mobil imza bilgileri alınamadı.",
        };
        console.log("Mobil imza bilgileri alınamadı: ", x);
      });
  },
  methods: {
    ChangeOperator(event){
      var op = event.target.value;
      console.log(this.eSignAgreement);
       axios
       .post("/mobilesign/updatemobilesign", {
          opt: op,
          sessionId: this.eSignAgreement?.SessionId
        }).then((x) => {        
        console.log(x);
      }).catch((x) => {        
        console.log(x);
      });
    },
    restartCountDown(val){
        try {
            this.$refs.countdown.restartTimer(val);
        }catch(e){
            console.log(e);
        }
        
    },
    setLoading(isLoading) {
      this.loading = isLoading;
      if(!isLoading) {
          this.restartCountDown(1);
          
      }
      this.$emit("onloading", isLoading);
    },
    cancel() {
      this.canceled = true;
      this.setLoading(false);
    },
    signDocument(index) {
      this.item = this.items[index];

      this.item.State = signStatus.prepearing;
      this.item.error = "";
      this.restartCountDown(this.circles[0].value);
      axios
        .get(this.item.FingerprintUrl)
        .then((x) => {
          console.log("Fingerprint result: ", x.data);
          if (x.data.Success) {
            this.item.Fingerprint = x.data.Data.Fingerprint;
            this.item.State = signStatus.signing;
            this.$forceUpdate();

            var dataUrl = this.item.PostUrl.replace(
              "{0}",
              x.data?.Data?.FingerPrintTempFileId
            );
            this.item.PostParams.FingerPrintTempFileId =
              x.data?.Data?.FingerPrintTempFileId;

            var postMethod = this.item.PostMethod ?? "get";
            var postParams = this.item.PostParams;

            console.log(dataUrl);

            setTimeout(() => {
              axios({
                url: dataUrl,
                method: postMethod,
                data: postParams,
              })
                .then((x) => {
                  console.log("mobile sign result:", x.data);
                  if (x.data.Success) {
                    this.item.State = signStatus.completed;
                    this.item.OK = true;
                    if (x.data.Data.Base64Signature)
                      this.item.SignedContent = x.data.Data.Base64Signature;

                    if (index + 1 < this.items.length) {
                      this.signDocument(index + 1);
                    } else {
                      console.log("signing complated function called");
                      this.$emit("completed", this.items);
                      this.setLoading(false);
                    }
                  }
                })
                .catch((x) => {
                  console.log("Mobil imza başarısız: ", x);
                  this.item.error = "İmzalama işlemi tamamlanamadı.";
                  this.item.State = signStatus.error;
                  this.item.OK = false;
                  this.setLoading(false);
                  this.timerShow = false;
                })
                .then(() => {
                  this.$forceUpdate();
                });
            }, 1500);
          } else {
            this.item.error = x.data.ErrorMessages;
            this.setLoading(false);
          }
        })
        .catch((x) => {
          this.item.error = "Parmak izi değeri hesaplanamadı.";
          console.log("Parmak izi alınamadı: ", x);
          this.setLoading(false);
        })
        .then(() => {
          this.$forceUpdate();
        });
    },
    sign() {
      this.timerShow = true;
      this.setLoading(true);
      this.signDocument(0);
    },
  },
};
</script>
<style scoped>
.panel-height {
    min-height: 100px;
}
@media (min-width: 768px) {
  .panel-height {
  height: 250px;
  }
}
.item-list {
        background: #FFF;
        border:1px solid #E0E0E0;
        height:200px;
        overflow-y: scroll;
    }
</style>